const refs = {
  form: document.querySelector('.search-form'),
  gallery: document.querySelector('.gallery'),
  loadMore: document.querySelector('.load-more'),
  submitBtn: document.querySelector('.btn-submit'),
};

export default refs;
